import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import PersonnelDetailChart from './PersonnelModal';
import useOutsideClick from 'hooks/useOutSideClick';
import useLockBodyScroll from 'hooks/useLockBodyScroll';
import { color } from 'asserts/styles/colors';
import { useAtomValue } from 'jotai';
import centerInforIdxAtom from 'atom/centerInforIdxAtom';
import companyIdxAtom from 'atom/companyIdxAtom';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys, restfetcher } from 'queryClient';
import commonYearAtom from 'atom/commonYear';
import commonMonthAtom from 'atom/commonMonth';

interface ModalProps {
  selectedLabel: string | null;
  selectedChartType: string | null;
  selectedData: string | null;
  onClickModal: () => void;
}

const PersonnelModalLayout = ({
  selectedLabel,
  selectedChartType,
  selectedData,
  onClickModal
}: ModalProps) => {
  const centerIdx = useAtomValue(centerInforIdxAtom);
  const companyIdx = useAtomValue(companyIdxAtom);
  const selectedYear = useAtomValue(commonYearAtom);
  const selectedMonth = useAtomValue(commonMonthAtom);

  const modalRef = useRef<HTMLDivElement | null>(null);

  const param = {
    companyidx: companyIdx,
    centeridx: centerIdx,
    year: selectedYear,
    month: selectedMonth,
    field: selectedChartType,
    sort: selectedData
  };

  const queryKey = [QueryKeys.PERSONNELDETAIL, param];

  const getChartDetailData = useQuery({
    queryKey: queryKey,
    queryFn: () =>
      restfetcher({
        method: 'POST',
        path: 'dashboard/employee/stats/detail',
        params: param
      })
  });

  const { data: detailData } = getChartDetailData;

  useEffect(() => {
    getChartDetailData.refetch();
  }, [selectedChartType]);

  useOutsideClick(modalRef, onClickModal);
  useLockBodyScroll();

  return (
    <Wrapper>
      <ModalWrapper ref={modalRef}>
        <DataWrapper>
          {detailData && (
            <PersonnelDetailChart
              selectedLabel={selectedLabel}
              detailData={detailData}
              selectedData={selectedData}
              selectedChartType={selectedChartType}
            />
          )}
        </DataWrapper>
        <CloseButton onClick={onClickModal}>닫기</CloseButton>
      </ModalWrapper>
    </Wrapper>
  );
};

export default PersonnelModalLayout;

const Wrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  font-family: 'Noto Sans KR', sans-serif;
  z-index: 9999;
`;

const ModalWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 420px;
  padding: 24px 32px;
  border-radius: 15px;
  background-color: ${color.white};
`;

const DataWrapper = styled.div``;

const CloseButton = styled.button`
  width: 356px;
  height: 36px;
  border-radius: 18px;
  background-color: ${color.mobile};
  color: ${color.white};
`;
